module.exports = __webpack_public_path__ + "static/img/son10_active.cc8533b9.png";